module.exports = __webpack_public_path__ + "img/bg2.74c2783b.jpg";